import type { Variants } from "motion/react";

import {
  DRAWER_MOTION_ENTER_DELAY_S,
  DRAWER_MOTION_ENTER_DURATION_S,
  getNumberWithoutPx,
  LEFT_BAR_WIDTH,
} from "@ryde/shared";

const drawerEnterTransition = {
  type: "tween",
  duration: DRAWER_MOTION_ENTER_DURATION_S,
  ease: "easeOut",
  delay: DRAWER_MOTION_ENTER_DELAY_S,
} as const;

export const drawerMotionAnimationVariants = ({
  isRtl = false,
}: {
  isRtl?: boolean;
} = {}): Variants => {
  const variants: Variants = {
    initial: custom => {
      const x = isRtl ? `-${custom}px` : custom;
      return { x };
    },
    exit: custom => ({
      x: isRtl ? `-${custom}px` : custom,
    }),
    animation: {
      x: 0,
      transition: drawerEnterTransition,
    },
  };
  return variants;
};

export const menuDrawerMotionAnimationVariants = (isRtl = false): Variants => {
  const variants: Variants = {
    initial: custom => {
      return {
        x: isRtl
          ? `${getNumberWithoutPx(custom) + LEFT_BAR_WIDTH}px`
          : `-${getNumberWithoutPx(custom) - LEFT_BAR_WIDTH}px`,
      };
    },
    exit: custom => ({
      x: isRtl ? `${custom}` : `-${custom}px`,
    }),
    animation: {
      x: isRtl ? -LEFT_BAR_WIDTH : LEFT_BAR_WIDTH,
      transition: drawerEnterTransition,
    },
  };
  return variants;
};
